<template>
	<div>
		<CModal
			:show.sync="isShow"
			:close-on-backdrop="false"
			centered
		>
			<template #header-wrapper>
				<ModalHeaderWrapper
					title="Add campaign SKU"
					@onClose="close"
				/>
			</template>
			<template #default>
				<CRow>
					<CCol>
						<FormGetPreOrderProductBySKU
							ref="form-sku"
							:sku-list="localSkuList"
							@onGetProduct="handleGet"
							@onRemove="handleRemove"
						>
							<template #no-item>
								<div
									class="no-item d-flex text-center"
									data-test-id="no-item"
								>
									<div class="d-block">
										<div class="no-sku font-weight-bolder color-black-45">
											No Campaign SKU yet
										</div>
										<div class="typo-body-2 color-black-45">
											Add "SKU number" in order to select campaign SKU
										</div>
									</div>
								</div>
							</template>
						</FormGetPreOrderProductBySKU>
					</CCol>
				</CRow>
			</template>
			<template #footer>
				<BaseModalFooter
					:total-select="localSkuList.length"
					@onClear="handleClear"
					@onCancel="handleCancel"
					@onConfirm="handleSubmit"
				/>
			</template>
		</CModal>
		<BaseModalConfirmDelete
			ref="modal-confirm"
			title="Leave without save?"
			description="All recently added SKUs will be discarded from SKU list"
			class="modal-on-modal"
			delete-button-text="Leave without save"
			@onSuccess="handleReset"
		/>
	</div>
</template>


<script>
import cloneDeep from 'lodash/cloneDeep';
import BaseModalFooter from '@/components/BaseModalFooter.vue';
import ModalHeaderWrapper from './ModalHeaderWrapper.vue';
import FormGetPreOrderProductBySKU from './FormGetPreOrderProductBySKU.vue';

export default {
	name: 'ModalCampaignSKU',
	components: {
		ModalHeaderWrapper,
		BaseModalFooter,
		FormGetPreOrderProductBySKU,
	},
	props: {
		skuList: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			isShow: false,
			localSkuList: [],
		};
	},
	methods: {
		open() {
			this.isShow = true;
			// When open, Re-sync list from props
			this.localSkuList = cloneDeep(this.skuList);
		},
		close() {
			this.isShow = false;
			this.$refs['form-sku'].resetState();
			this.localSkuList = [];
		},
		handleGet(products) {
			this.localSkuList = [...products];
		},
		handleRemove(product) {
			this.localSkuList = this.localSkuList.filter((skuProduct) => skuProduct.sku !== product.sku);
		},
		handleCancel() {
			this.$refs['modal-confirm'].open();
		},
		handleReset() {
			this.close();
		},
		handleClear() {
			this.localSkuList = [];
		},
		handleSubmit() {
			this.isShow = false;
			this.$emit('onConfirm', this.localSkuList);
		},
	},
};
</script>

<style lang="scss" scoped>
	.no-item {
		min-height: rem(200);
		justify-content: center;
		align-items: center;
	}

	::v-deep .list-item {
		min-height: rem(200);
		padding: 0;
		margin: 0;
	}
</style>
